import { ReactComponent as PencilDrawing } from '../../assets/icons/pencil.svg';

export default function PencilIcon() {
  return <PencilDrawing className="pencil-icon" aria-hidden="true" focusable="false" />;
}
